<div class="preview-details-container d-flex flex-column gap-4">
    <div class="d-flex align-items-start" >
        <div class="preview-details-header flex-grow-1 d-flex flex-column mb-3">
            <div class="d-flex align-items-center gap-3 mb-2">
                <button class="btn link-btn btn-back">
                    <i class="app-icon icon icon-chevron-left icon-xl" (click)="redirectListHandler()"></i>
                </button>
                <div class="preview-details-type fw-bold">
                    {{ 'specialOffers.preview.title' | translate }}
                </div>
            </div>
        </div>
    </div>
    <preview-selector 
        *ngIf="specialOfferId && (status === specialOfferStatus.ONGOING || status === specialOfferStatus.ENDED)" 
        class="mb-3 w-100"         
        [selectedTab]="selectedTab" 
        (tabChange)="tabChangeHandler($event)">
    </preview-selector>

    @switch (selectedTab) {
        @case (SPECIAL_OFFER_PREVIEW.INFO) {
        <preview-information 
            [specialOfferId]="specialOfferId" 
            (formChanged)="formChangeHandler($event)"
            (setSpecialOfferStatus)="setSpecialOfferStatus($event)"
            (unloadForm)="unloadByPassForm($event)">
        </preview-information>
        }
        @case (SPECIAL_OFFER_PREVIEW.INSIGHTS) {
        <special-offer-insight [specialOfferId]="specialOfferId"></special-offer-insight>
        }
    }
</div>